<p>dealer-info works!</p>
